module.exports = __webpack_public_path__ + "img/小箭头.cde12dee.svg";